import { Button } from 'antd';
import './index.less';
import { CatalogItem, CatalogItemMoq } from '@/shared/types/catalog';
import React, { forwardRef, LegacyRef, useMemo, useState } from 'react';
import { useCreateAccountProvider } from '@/lib/context';
import { getCreatorHubProductDetailsPagePath, getSortedMoqInfo } from '@/shared/utils/sourcing-marketplace-util';
import { isEmpty } from 'lodash-es';
import cN from 'classnames';
import { formatCurrency } from '@/shared/utils/utils';
import { WORK_WITH_FACTORIES_DESCRIPTION } from '@/shared/constants/sourcing-marketplace';
import ArrowButtonDownIcon from '@/components/Common/Icons/ArrowButtonDownIcon';
import { MessagesBubbleQuotation } from '@/components/Common/Icons';
import { useIsMobileURL } from '@/shared/hooks';

interface ProductRunCardProps {
  product: CatalogItem;
}

const ProductRunCard = forwardRef(({ product }: ProductRunCardProps, ref) => {
  // const { isMobile } = useConfigProvider();
  const isMobile = useIsMobileURL();
  const { showSignupDialogFromSourcing } = useCreateAccountProvider();
  const [seeMoreMoq, setSeeMoreMoq] = useState(false);
  const moqInfo = useMemo(() => getSortedMoqInfo(product), [product]);

  const handleSeeMore = () => {
    setSeeMoreMoq(!seeMoreMoq);
  };

  const startOrderClicked = () => {
    showSignupDialogFromSourcing(
      WORK_WITH_FACTORIES_DESCRIPTION,
      getCreatorHubProductDetailsPagePath(product.id, 'source'),
      'product_details_page',
    );
  };

  return (
    <>
      {!isEmpty(moqInfo) && (
        <div
          ref={ref as LegacyRef<HTMLDivElement>}
          className={cN('product-run-card', { 'product-run-card-mobile': isMobile })}
        >
          <h3 className="title">Start a project</h3>
          <div className="costs-box">
            {!isMobile && (
              <div className="title-item">
                <p>Cost</p>
                <p>Quantity</p>
              </div>
            )}

            <>
              {moqInfo?.slice(0, 3).map((moq: CatalogItemMoq) => {
                return (
                  <div className="cost-item" key={`moqInfo-${moq.price}-${moq.qty}`}>
                    <p>{formatCurrency(moq.price)}</p>
                    <p>
                      {moq.qty}
                      {moq.qty > 1 ? ' units' : ' unit'}
                    </p>
                    {!isMobile && (
                      <Button onClick={startOrderClicked} className="start-order-button">
                        Start order
                      </Button>
                    )}
                  </div>
                );
              })}
              {moqInfo?.length > 3 && (
                <>
                  {seeMoreMoq && (
                    <>
                      {moqInfo?.slice(3).map((moq: CatalogItemMoq) => {
                        return (
                          <div className="cost-item" key={`moqInfo-${moq.price}-${moq.qty}`}>
                            <p>{formatCurrency(moq.price)}</p>
                            <p>
                              {moq.qty}
                              {moq.qty > 1 ? 'units' : 'unit'}
                            </p>
                            {!isMobile && (
                              <Button onClick={startOrderClicked} className="start-order-button">
                                Start order
                              </Button>
                            )}
                          </div>
                        );
                      })}
                    </>
                  )}
                  <div onClick={handleSeeMore} className={cN('see-more-box', { 'see-more-box-expand': seeMoreMoq })}>
                    <p className="see-more-text">See more</p>
                    <ArrowButtonDownIcon style={{ fill: '#A1A1A1' }} />
                  </div>
                </>
              )}
            </>
          </div>
          <div onClick={startOrderClicked} className="contact-supplier-btn">
            <MessagesBubbleQuotation />
            <span>Work with supplier</span>
          </div>
        </div>
      )}
    </>
  );
});

export default ProductRunCard;
